.screen {
	/* Fixed-height layout — fills the scroll area above the tab bar. */
	height: 100%;
	padding: var(--space-5);
	max-width: var(--screen-max);
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
}

/* Header control that enters and leaves select mode. Outlined pill matching
   the Family code copy button, at the height every other header control uses. */
.mode {
	display: inline-flex;
	align-items: center;
	height: var(--control-h);
	padding: 0 var(--space-3);
	background: none;
	border: 1px solid var(--border);
	border-radius: var(--radius-md);
	font: inherit;
	font-size: 0.85rem;
	font-weight: 600;
	color: var(--ink-muted);
	cursor: pointer;
	white-space: nowrap;
}

.mode:hover:not(:disabled) {
	color: var(--ink);
	background: var(--surface-input);
}

.mode:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

/* Status line: how many days are picked, and the two bulk controls. */
.count {
	flex: 1;
	min-width: 0;
	font-weight: 600;
	color: var(--ink);
}

.stripActions {
	display: flex;
	gap: var(--space-3);
}

.stripAction {
	background: none;
	border: none;
	padding: 0;
	font: inherit;
	font-size: 0.8125rem;
	color: var(--accent-sage);
	cursor: pointer;
	white-space: nowrap;
}

.stripAction:disabled {
	color: var(--ink-muted);
	opacity: 0.5;
	cursor: default;
}

/* Action bar. Three columns with equal shoulders, so the middle control is
   centred in the strip whatever width the other two come out at — an icon on
   one of them can't pull the group off centre. */
.actions {
	flex: 1;
	display: grid;
	grid-template-columns: 1fr auto 1fr;
	align-items: center;
	gap: var(--space-2);
}

.actionsLeft {
	justify-self: end;
}

.actionsRight {
	justify-self: start;
}

.action {
	display: inline-flex;
	align-items: center;
	gap: var(--space-2);
	padding: var(--space-1) var(--space-3);
	background: none;
	border: none;
	border-radius: var(--radius-sm);
	font: inherit;
	font-weight: 600;
	color: var(--ink-muted);
	cursor: pointer;
	white-space: nowrap;
}

/* The same lilac the proposed rows are tinted with, so the button and what it
   produces are the one colour. */
.actionSuggest {
	color: var(--accent-lilac);
}

.actionAccept {
	color: var(--accent-sage);
}

/* Destructive, so it takes the same rose as the confirm dialog. */
.actionDanger {
	color: var(--accent-rose);
}

.action:disabled {
	color: var(--ink-muted);
	opacity: 0.5;
	cursor: default;
}

.status {
	color: var(--ink-muted);
	text-align: center;
	margin: 0;
}

.retry {
	background: none;
	border: none;
	color: var(--accent-sage);
	cursor: pointer;
	font: inherit;
	padding: 0;
	text-decoration: underline;
}
